import Skeleton from '@mui/material/Skeleton';

import { UsageCardProps } from './types';
import { Container } from './styles';

export function UsageCard({
  value,
  label,
  icon,
  color,
  loading,
}: UsageCardProps) {

  return (
    <Container elevation={3} color={color}>
      <p>{label}</p>

      {icon && <div className="icon-container">{icon}</div>}

      {(typeof value !== 'undefined' && !loading)
        ? <strong>{value}</strong>
        : <Skeleton variant="text" width={60} height={27} />
      }
    </Container>
  )
}
